import { render } from "./DetailView.vue?vue&type=template&id=85d2b986&lang=pug"
import script from "./DetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailView.vue?vue&type=script&setup=true&lang=js"

import "./DetailView.vue?vue&type=style&index=0&id=85d2b986&lang=scss"

import exportComponent from "/Users/jon.bloom/Documents/Clients/Freshwater/ise-ds-awards-2022-microsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__